/**
 * Generate the appropriate cookie domain for session cookies
 * This mirrors the backend AppUrlsHelper.cookie_domain method
 *
 * NOTE: Cookie domains cannot include port numbers - browsers will reject them
 */
export function cookieDomain(): string {
  // Use the port-free domain for cookie setting
  const domain = process.env.NEXT_PUBLIC_DOMAIN

  if (!domain) {
    throw new Error('NEXT_PUBLIC_DOMAIN environment variable is not set')
  }

  // Return with leading dot for subdomain sharing (matches backend behavior)
  // Don't include port in cookie domain as browsers cannot set cookies with ports
  return `.${domain}`
}
